/******************************************************************************
Mowing Reducer: Handles all interactions & state changes with the mowing component
Hawaiian Macadamia Nut Services
Alexander Self
03/18/20
*Note: Day 9 of quarantine.
*******************************************************************************/
import { ADD_MOWING_RECORD, EDIT_MOWING_RECORD, SELECT_MOW_TO_EDIT, DELETE_MOWING_RECORD,
 PREPARE_MOWING_APPLICATION, CREATE_MOWING_APPLICATION, FETCH_MOWING_APPLICATIONS, SELECT_MOWING_APPLICATION,
 DELETE_MOWING_APPLICATION, SELECT_MOW_APP_TO_EDIT, EDIT_MOWING_APPLICATION, CLEAR_FORM, ERROR } from '../actions/types';
let initState = {
  mowingRecords: {
    all: [],
    displaying: []
  },
  view: {
    app: {}
  },
  app: {
    editingApplication: false,
    selectedFields: [],
    type: CREATE_MOWING_APPLICATION, // type of action
    path: 'createMowingApplication',
    mowJobs: [],
    mowAppId: null, // Application ID if editing
    isEditing: false,
    editingMow: {}, // Mow being edited
    application: {}, // Application to submit
    previousApplications: [], // Previous applications within the same field, round
    deletedMowingRecords: [] // Fertilizers applied deleted during the app edit process(deletes serverside)
  }
};

export default function MowingReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_MOWING_APPLICATIONS:
      return { ...state,
        mowingRecords: {
          all: action.payload,
          displaying: action.payload
        }
      };
    case ADD_MOWING_RECORD:
      return { ...state,
        app: { ...state.app,
          mowJobs: state.app.mowJobs.concat(action.payload)
        }
      };
    case EDIT_MOWING_RECORD:
      return { ...state,
        app: { ...state.app,
          mowJobs: state.app.mowJobs.filter((m) => m.id !== state.app.editingMow.id).concat(action.payload),
          editingMow: initState.app.editingMow,
          isEditing: initState.app.isEditing
        }
      };
    case SELECT_MOW_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          isEditing: true,
          editingMow: action.payload
        }
      };
    case DELETE_MOWING_RECORD:
      return { ...state,
        app: { ...state.app,
          mowJobs: state.app.mowJobs.filter((m) => m.id !== action.payload.id),
          deletedMowingRecords: state.app.deletedMowingRecords.concat(action.payload)
        }
      };
    case PREPARE_MOWING_APPLICATION:
      return { ...state,
        app: { ...state.app,
          application: action.payload,
          previousApplications: action.prevApps
        }
      };
    case CREATE_MOWING_APPLICATION:
      return { ...state,
        mowingRecords: {
          all: state.mowingRecords.all.concat(action.payload),
          displaying: state.mowingRecords.displaying.concat(action.payload)
        },
        app: initState.app
      }
    case SELECT_MOWING_APPLICATION:
      return { ...state,
        view: {
          app: action.payload
        }
      };
    case DELETE_MOWING_APPLICATION:
      return { ...state,
        mowingRecords: {
          all: state.mowingRecords.all.filter((m) => m.mowAppId !== action.payload),
          displaying: state.mowingRecords.displaying.filter((m) => m.mowAppId !== action.payload)
        }
      }
    case SELECT_MOW_APP_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          type: EDIT_MOWING_APPLICATION,
          path: 'editMowingApplication',
          editingApplication: true,
          mowAppId: action.payload.mowAppId,
          mowJobs: action.payload.mowJobs,
          deletedMowingRecords: initState.app.deletedMowingRecords,
          previousApplications: initState.app.previousApplications
        }
      };
    case EDIT_MOWING_APPLICATION:
      return { ...state,
        mowingRecords: {
          all: state.mowingRecords.all.filter((m) => m.id !== action.payload.id).concat(action.payload),
          displaying: state.mowingRecords.displaying.filter((m) => m.id !== action.payload.id).concat(action.payload)
        },
        app: initState.app
      };
    case CLEAR_FORM:
      return { ...state,
        app: initState.app
      }
    case ERROR:
      return state;
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/mowing_reducer.js